import React from 'react'

const Services = () => {
  const services = [
    {
      title: "Wedding Events",
      icon: "fa-ring",
      gradient: "from-[#f093fb] to-[#f5576c]",
      items: [
        "Complete wedding planning & coordination",
        "Mandap decoration & stage setup",
        "Floral arrangements & lighting",
        "Mehandi artists & entertainment",
        "Photography & videography services",
        "Audio system & DJ services"
      ]
    },
    {
      title: "Birthday Parties",
      icon: "fa-birthday-cake",
      gradient: "from-[#667eea] to-[#764ba2]",
      items: [
        "Themed birthday decorations",
        "Kids entertainment & activities",
        "Balloon sculpting & face painting",
        "Magicians & artists",
        "Return gifts & party supplies",
        "Photo & video booths"
      ]
    },
    {
      title: "Corporate Events",
      icon: "fa-building",
      gradient: "from-[#1abc9c] to-[#16a085]",
      badge: "🔥 Popular",
      items: [
        "Product launches & conferences",
        "Team building activities",
        "Annual day celebrations",
        "Brand activation events",
        "Corporate entertainment",
        "Exhibition & stall setup"
      ]
    },
    {
      title: "Engagement & Baby Shower",
      icon: "fa-heart",
      gradient: "from-[#fa709a] to-[#fee140]",
      items: [
        "Elegant engagement decorations",
        "Baby shower theme decor",
        "Gender reveal setups",
        "Photo booth & backdrops",
        "Games & entertainment",
        "Catering coordination"
      ]
    },
    {
      title: "College & School Events",
      icon: "fa-graduation-cap",
      gradient: "from-[#4facfe] to-[#00f2fe]",
      items: [
        "College cultural festivals",
        "School annual day setup",
        "Sports day events",
        "Kids day celebrations",
        "Carnival setups & games",
        "Stage & audio setup"
      ]
    },
    {
      title: "Stage & Technical Setup",
      icon: "fa-microphone-alt",
      gradient: "from-[#ff6b6b] to-[#ee5a24]",
      items: [
        "Professional stage design & setup",
        "Audio system & sound engineering",
        "LED screen & projection",
        "Lighting design & effects",
        "Truss & rigging setup",
        "Technical crew support"
      ]
    }
  ]

  return (
    <section id="services" className="py-16 px-4 md:px-6">
      <div className="container mx-auto">
        <div className="section-bg">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold section-title-enhanced mb-6">
              🎯 Our Comprehensive Services
            </h2>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed">
              Chennai's best & premium event management solutions tailored to your unique vision. From weddings to corporate events across Tamil Nadu, we cover every aspect from planning to execution.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <article key={index} className="card p-8">
                {service.badge && <div className="premium-badge">{service.badge}</div>}
                <div className="text-center mb-6">
                  <div className={`w-20 h-20 mx-auto mb-4 bg-gradient-to-r ${service.gradient} rounded-full flex items-center justify-center`}>
                    <i className={`fas ${service.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-gray-800">
                    {service.title}
                  </h3>
                </div>
                <ul className="space-y-3 text-gray-700">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="fas fa-check-circle text-[#1abc9c] mt-1 mr-3"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services
